<template>
	<div id="app" :style="{ backgroundColor: bgColor }">
		<CommonHeader v-if="showHeader" :title="$route.meta.title || ''" :background-color="bgColor" />
		<keep-alive v-if="isRouterAlive">
			<router-view v-if="$route.meta.keepAlive" :class="showHeader ? 'page-content haveHeader' : 'page-content'" />
		</keep-alive>
		<router-view v-if="!$route.meta.keepAlive" :class="showHeader ? 'page-content haveHeader' : 'page-content'" />
		<!-- <van-tabbar v-if="showTabbar" route safe-area-inset-bottom>
			<van-tabbar-item v-for="tab in tabsList" :key="tab.key" :to="tab.to">
				<span class="tabTitle">{{ tab.title }}</span>
				<img slot="icon" :src="isActive(tab.to) ? tab.activeIcon : tab.icon" class="tabbar-icon" />
			</van-tabbar-item>
		</van-tabbar> -->
	</div>
</template>

<script>
	// import FloatGifIcon from './components/FloatGifIcon.vue'
	import homeIcon from "@/assets/image/homePage.svg";
	import homeActiveIcon from "@/assets/image/homePageActive.svg";
	import orderIcon from "@/assets/image/orderPage.svg";
	import orderActiveIcon from "@/assets/image/orderPageActive.svg";
	import healthIcon from "@/assets/image/healthData.svg";
	import healthActiveIcon from "@/assets/image/healthDataActive.svg";
	import profileIcon from "@/assets/image/profilePage.svg";
	import profileActiveIcon from "@/assets/image/profilePageActive.svg";
	import CommonHeader from "@/components/CommonHeader.vue";

	export default {
		name: "App",
		components: {
			CommonHeader,
			// FloatGifIcon
		},
		data() {
			return {
				tabs: [{
						key: "home",
						title: "首页",
						to: "/home",
						icon: homeIcon,
						activeIcon: homeActiveIcon,
					},
					{
						key: "order",
						title: "订单中心",
						to: "/order",
						icon: orderIcon,
						activeIcon: orderActiveIcon,
					},
					{
						key: "health",
						title: "健康数据",
						to: {
							name: "health",
							query: {
								tableType: 3
							}
						},
						icon: healthIcon,
						activeIcon: healthActiveIcon,
					},
					{
						key: "profile",
						title: "个人中心",
						to: "/profile",
						icon: profileIcon,
						activeIcon: profileActiveIcon,
					},
				],
				tabsServe: [{
						key: "serveHome",
						title: "首页",
						to: "/serveHome",
						icon: homeIcon,
						activeIcon: homeActiveIcon,
					},
					{
						key: "serveOrder",
						title: "订单中心",
						to: "/serveOrder",
						icon: orderIcon,
						activeIcon: orderActiveIcon,
					},
					{
						key: "serveProfile",
						title: "个人中心",
						to: "/serveProfile",
						icon: profileIcon,
						activeIcon: profileActiveIcon,
					},
				],
				tabsServeGj: [{
						key: "serveHomeGj",
						title: "首页",
						to: "/serveHomeGj",
						icon: homeIcon,
						activeIcon: homeActiveIcon,
					},
					{
						key: "serveOrder",
						title: "订单中心",
						to: "/serveOrder",
						icon: orderIcon,
						activeIcon: orderActiveIcon,
					},
					{
						key: "serveGJProfile",
						title: "个人中心",
						to: "/serveGJProfile",
						icon: profileIcon,
						activeIcon: profileActiveIcon,
					},
				],
				isRouterAlive: true
			};
		},
		// 给子组件提供缓存刷新方法
		provide () { 
			return { reload: this.reload } 
		},
		// 子组件使用inject接收加缓存刷新
		// beforeRouteEnter (to, from, next) {
		// 	if (from.path == '/serveHome') {
		// 		next(vm => {
		// 			vm.reload()
		// 		})
		// 	} else {
		// 		next()
		// 	}
 		// },
		computed: {
			showTabbar() {
				return this.$route.meta.showTabbar !== false;
			},
			showHeader() {
				return this.$route.meta.showHeader !== false;
			},
			bgColor() {
				return this.$route.meta.backgroundColor || "#fff"; // 默认值与原 body 一致
			},
			tabsList() {
				const userInfo = this.$store.state.info;
				if (!userInfo || userInfo.type == "1") {
					return this.tabs;
				}
				if (userInfo.type == "2") {
					return this.tabsServe;
				}
				if (userInfo.type == "3") {
					return this.tabsServeGj;
				}
				return this.tabs;
			},
		},
		methods: {
			isActive(path) {
				return this.$route.path === path;
			},
			reload () {
				this.isRouterAlive = false
				this.$nextTick(() => (this.isRouterAlive = true))
			}
		},
	};
</script>

<style scoped>
	* {
		margin: 0;
		padding: 0;
		box-sizing: border-box;
	}

	body,
	html {
		margin: 0;
		padding: 0;
		height: 100%;
	}

	#app {
		width: 100%;
		min-height: 100vh;
		min-height: 100dvh;
		/* 改用 min-height 确保撑满 */
		display: flex;
		flex-direction: column;
	}

	.page-content {
		flex: 1;
		overflow-y: auto;
	}

	.haveHeader {
		padding-top: 40px !important;
	}

	.van-tabbar {
		height: 60px;
		flex-shrink: 0;
	}

	.tabbar-icon {
		width: 20px;
		height: 20px;
		display: block;
		margin: 0 auto 4px;
	}

	.tabTitle {
		font-size: 14px;
	}
</style>